export class Paginator {
  constructor( page = 1, size = 10, orderBy = null) { // { direction, orderBy }
      this.page = Number(page);
      this.size = Number(size);

      this.orderBy = orderBy;
  }

  setOffset(offset) {
    this.page = null;
    this.offset = offset < 0 ? 0 : offset;
    return this;
  }

  toParams() {
    const params = {
      size: this.size,
      ...this.orderBy,
    };

    if(this.page !== null) {
      params.page = this.page;
    }

    if(this.offset !== null) {
      params.offset = this.offset;
    }

    return params;
  }
}

export class PaginatedResponse {
  // items: T[];
  // totalCount: number;
  // limit?: number;
  // page?: number;

  constructor() {
    // this.items = [];
    // this.totalCount = 0;
  }
}